/* ============================================================
   TCG PRODUCT - variant logic (assets/tcg-product.js)
   Selection of Condizione (option1) + Lingua (option2) + Rarita (option3)
   resolves the matching Shopify variant and updates image, price, stock,
   Add-to-cart, details and the mobile sticky bar. Rarity drives the image
   via variant.featured_image (fallback product.featured_image).
   ============================================================ */
(function () {
  const root = document.querySelector('[data-tcg-root]');
  if (!root) return;

  const variants = JSON.parse(root.querySelector('[data-tcg-variants]').textContent);
  const meta = JSON.parse(root.querySelector('[data-tcg-product]').textContent);
  const moneyFormat = root.dataset.moneyFormat || '${{amount}}';

  /* ---------- real availability from inventory (CSV: Variant Inventory Qty / Policy) ----------
     A variant is buyable when:
       - inventory is NOT tracked (inventory_management null) -> respect variant.available, OR
       - tracked with policy "continue" (oversell allowed) -> buyable, OR
       - tracked with policy "deny" -> only if inventory_quantity > 0.
     Quantity shown is inventory_quantity (clamped at 0). */
  function qtyOf(v) {
    const q = (typeof v.inventory_quantity === 'number') ? v.inventory_quantity : 0;
    return Math.max(0, q);
  }
  function buyable(v) {
    if (!v) return false;
    if (v.price <= 0) return false;
    if (!v.inventory_management) return !!v.available;
    return qtyOf(v) > 0;
  }
  variants.forEach(v => {
    v.buyable = buyable(v);
    v.count = qtyOf(v);
  });

  /* ---------- money ---------- */
  function formatMoney(cents) {
    const v = (cents / 100);
    const withComma = v.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const withDot = v.toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, withDot)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(v).toString());
  }

  /* ---------- parse rarity string ---------- */
  function normalizeRarityKey(value) {
    return (value || '').replace(/\s+/g, '').toLowerCase();
  }
  function rarityBadgeClass(value) {
    const key = normalizeRarityKey(value);
    if (key === 'common' || key === 'c' || key === 'uncommon' || key === 'uc') return 'common';
    if (key === 'rare' || key === 'rara' || key === 'r') return 'rare';
    if (key === 'epic' || key === 'epica' || key === 'e') return 'epic';
    return 'rainbow';
  }
  function parseRarity(raw) {
    const text = (raw || '').trim();
    const low = text.toLowerCase();
    const parts = text.split('-');
    const badge = (parts[0] || '').trim() || text;
    const version = parts.slice(1).join(' - ').replace(/[()]/g, '').trim();
    const tone = (low.includes('alternate art') || low.includes('alt art') || low.includes('showcase') || low.includes('foil'))
      ? 'holo'
      : 'flat';
    return { name: version, setDetail: version, tone, badge, badgeClass: rarityBadgeClass(badge) };
  }

  /* ---------- ordered rarities (option3) ---------- */
  const rarities = [];
  const seen = {};
  variants.forEach(v => {
    if (!seen[v.option3]) {
      seen[v.option3] = true;
      const info = parseRarity(v.option3);
      const pool = variants.filter(x => x.option3 === v.option3);
      const avail = pool.filter(x => x.buyable);
      const minPrice = Math.min.apply(null, (avail.length ? avail : pool).map(x => x.price));
      const totalQty = avail.reduce((s, x) => s + (x.count || 0), 0);
      rarities.push({
        key: v.option3,
        ...info,
        minPrice,
        status: avail.length === 0 ? 'out' : (totalQty > 0 && totalQty <= 3 ? 'low' : 'in'),
        image: (meta.rarity_images && meta.rarity_images[v.option3]) || meta.featured_image,
      });
    }
  });

  /* ---------- state ---------- */
  const initial = variants.find(v => v.buyable) || variants[0];
  let sel = { option1: initial.option1, option2: initial.option2, option3: initial.option3 };

  const findVariant = (s) => variants.find(v => v.option1 === s.option1 && v.option2 === s.option2 && v.option3 === s.option3) || null;
  const isAvail = (s) => {
    const v = findVariant(s);
    return !!(v && v.buyable);
  };

  /* ---------- DOM refs ---------- */
  const $ = (q) => root.querySelector(q);
  const mainImg = $('[data-tcg-main-image]');
  const sheen = $('[data-tcg-sheen]');
  const priceEl = $('[data-tcg-price]');
  const stockEl = $('[data-tcg-stock]');
  const variantIdEl = $('[data-tcg-variant-id]');
  const addBtn = $('[data-tcg-add]');
  const addLabel = $('[data-tcg-add-label]');
  const buyNow = $('[data-tcg-buynow]');
  const qtyInput = $('[data-tcg-qty]');
  const qtyMinus = $('[data-tcg-qty-minus]');
  const qtyPlus = $('[data-tcg-qty-plus]');
  const rarityWrap = $('[data-tcg-rarities]');
  const rarityCount = $('[data-tcg-rarity-count]');

  function quantityLimitFor(variant) {
    if (!variant) return 1;
    if (!variant.inventory_management) return null;
    if (variant.inventory_policy === 'continue') return null;
    return Math.max(1, variant.count || 0);
  }
  function syncQtyInput(variant) {
    if (!qtyInput) return;
    const limit = quantityLimitFor(variant);
    qtyInput.min = '1';
    if (limit == null) qtyInput.removeAttribute('max');
    else qtyInput.max = String(limit);
    let qty = parseInt(qtyInput.value || '1', 10);
    if (!Number.isFinite(qty) || qty < 1) qty = 1;
    if (limit != null) qty = Math.min(qty, limit);
    qtyInput.value = String(qty);
    syncQtyButtons(variant, qty);
  }
  function currentQty() {
    const q = parseInt((qtyInput && qtyInput.value) || '1', 10);
    return Number.isFinite(q) && q > 0 ? q : 1;
  }
  // Bug osservato 2026-09-11: il vecchio listener 'input' richiamava syncQtyInput ad OGNI tasto
  // premuto, che riscrive .value clampato al limite corrente — scrivendo un numero a più cifre
  // (o con un valore residuo già vicino al massimo) il clamp scattava a metà digitazione e il
  // campo saltava al massimo consentito prima che l'utente finisse di scrivere. Il clamp "duro" va
  // fatto solo a digitazione conclusa (blur) o prima dell'invio al carrello (già in submitCart),
  // mai ad ogni keystroke — durante la digitazione si aggiornano solo i bottoni +/-.
  function syncQtyButtons(variant, qtyOverride) {
    const limit = quantityLimitFor(variant || activeVariant());
    const q = typeof qtyOverride === 'number' ? qtyOverride : currentQty();
    if (qtyMinus) qtyMinus.disabled = q <= 1;
    if (qtyPlus) qtyPlus.disabled = limit != null && q >= limit;
  }
  function setQty(value, variant) {
    if (!qtyInput) return;
    const limit = quantityLimitFor(variant || activeVariant());
    let next = Math.max(1, Math.floor(value) || 1);
    if (limit != null) next = Math.min(next, limit);
    qtyInput.value = String(next);
    syncQtyButtons(variant, next);
  }
  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
  function syncThemeCartCount(cart) {
    const count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    [
      '[data-cart-count]',
      '[data-cart-count-bubble]',
      '.cart-count-bubble',
      '.cart-count',
      '#cart-icon-bubble'
    ].forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        el.textContent = String(count);
        el.hidden = count === 0;
        el.toggleAttribute('data-empty', count === 0);
      });
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
  }
  async function refreshCartBadge() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await res.json().catch(() => null);
    if (cart) syncThemeCartCount(cart);
  }

  /* ---------- build rarity cards ---------- */
  const MOBILE_MAX = 4; // quante versioni mostrare su mobile prima del "mostra tutte"
  rarityCount.textContent = rarities.length + ' versioni';

  rarities.forEach((r, idx) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tcg__rc' + (r.status === 'out' ? ' is-out' : '');
    btn.dataset.rarity = r.key;
    btn.dataset.rcIdx = idx;
    if (idx >= MOBILE_MAX) btn.classList.add('tcg__rc--hidden-mobile');
    const badgeHtml = `<span class="tcg__badge tcg__badge--${r.badgeClass}">${escapeHtml(r.badge)}</span>`;
    const nameHtml = r.name ? `<span class="tcg__rc-name">${escapeHtml(r.name)}</span>` : '';
    const statLabel = { in: 'Disponibile', low: 'Pochi pezzi', out: 'Esaurito' }[r.status];
    const thumbHtml = r.image
      ? `<img src="${r.image}" alt="${escapeHtml(r.badge)}" loading="lazy">`
      : '';
    btn.innerHTML =
      `<span class="tcg__rc-thumb${r.tone === 'holo' ? ' is-foil' : ''}">${thumbHtml}</span>` +
      `<span class="tcg__rc-body">` +
        `<span class="tcg__rc-head">${nameHtml}${badgeHtml}</span>` +
        `<span class="tcg__rc-foot"><span class="tcg__rc-price">${formatMoney(r.minPrice)}</span>` +
        `<span class="tcg__rc-stat ${r.status}">${statLabel}</span></span>` +
      `</span><span class="tcg__rc-check">✓</span>`;
    btn.addEventListener('click', () => selectRarity(r.key));
    rarityWrap.appendChild(btn);
  });

  // Bottone "Mostra tutte" visibile solo su mobile quando ci sono > MOBILE_MAX versioni
  if (rarities.length > MOBILE_MAX) {
    const moreBtn = document.createElement('button');
    moreBtn.type = 'button';
    moreBtn.className = 'tcg__rarities-more';
    moreBtn.textContent = `Mostra tutte le versioni (${rarities.length})`;
    moreBtn.addEventListener('click', () => {
      rarityWrap.querySelectorAll('.tcg__rc--hidden-mobile').forEach(el => {
        el.classList.remove('tcg__rc--hidden-mobile');
      });
      moreBtn.remove();
    });
    rarityWrap.appendChild(moreBtn);
  }

  /* mark foil variant thumbnails in the gallery strip + click selects best matching variant */
  root.querySelectorAll('[data-tcg-variant-thumb]').forEach(th => {
    const vid = th.dataset.tcgVariantThumb;
    const v = variants.find(x => String(x.id) === vid);
    if (!v) return;
    const info = parseRarity(v.option3);
    if (info.tone === 'holo') th.classList.add('is-foil');
    th.addEventListener('click', () => {
      const imageId = (v.featured_image && v.featured_image.id != null) ? String(v.featured_image.id) : null;
      const pool = imageId
        ? variants.filter(x => x.featured_image && String(x.featured_image.id) === imageId)
        : [v];
      const exact = pool.find(x => x.option2 === sel.option2 && x.option1 === sel.option1 && x.buyable);
      const keepLang = pool.find(x => x.option2 === sel.option2 && x.buyable);
      const keepCond = pool.find(x => x.option1 === sel.option1 && x.buyable);
      const fallback = pool.find(x => x.buyable) || pool[0] || v;
      const next = exact || keepLang || keepCond || fallback;
      sel = { option1: next.option1, option2: next.option2, option3: next.option3 };
      render();
    });
  });

  /* ---------- selection logic ---------- */
  function selectRarity(key) {
    const pool = variants.filter(v => v.option3 === key);
    let lang = sel.option2;
    // Keep current language only if it has at least one buyable variant for this rarity
    if (!pool.some(v => v.option2 === lang) || !pool.some(v => v.option2 === lang && v.buyable)) {
      lang = (pool.find(v => v.buyable) || pool[0]).option2;
    }
    let cond = sel.option1;
    const condPool = pool.filter(v => v.option2 === lang);
    if (!condPool.some(v => v.option1 === cond && v.buyable)) {
      cond = (condPool.find(v => v.buyable) || condPool[0] || pool[0]).option1;
    }
    sel = { option1: cond, option2: lang, option3: key };
    render();
  }
  function selectOption(which, value) {
    const next = { ...sel, [which]: value };
    if (which === 'option2') {
      // Versione corrente non acquistabile in questa lingua: passa alla prima versione che lo è,
      // altrimenti la lingua resterebbe irraggiungibile (bug 2026-09-29: Nami OP09-050, 23 copie
      // inglesi invisibili perché la versione iniziale era un'Alternate Art solo giapponese).
      if (!variants.some(v => v.option2 === value && v.option3 === sel.option3 && v.buyable)) {
        const other = variants.find(v => v.option2 === value && v.buyable);
        if (other) next.option3 = other.option3;
      }
      const pool = variants.filter(v => v.option2 === value && v.option3 === next.option3);
      if (!pool.some(v => v.option1 === next.option1 && v.buyable)) {
        const fallback = pool.find(v => v.buyable) || pool[0];
        if (fallback) next.option1 = fallback.option1;
      }
    }
    sel = next;
    render();
  }

  /* ---------- pills ---------- */
  root.querySelectorAll('[data-tcg-options]').forEach(group => {
    const which = group.dataset.tcgOptions;
    group.querySelectorAll('.tcg__pill').forEach(pill => {
      pill.addEventListener('click', () => {
        if (pill.hasAttribute('disabled')) return;
        selectOption(which, pill.dataset.value);
      });
    });
  });

  /* ---------- render ---------- */
  function render() {
    const variant = findVariant(sel) || variants.filter(v => v.option3 === sel.option3).find(v => v.buyable) || variants.filter(v => v.option3 === sel.option3)[0];
    const rInfo = parseRarity(sel.option3);
    const image = (variant && variant.featured_image && variant.featured_image.src)
      || (meta.rarity_images && meta.rarity_images[sel.option3])
      || meta.featured_image;

    if (image && mainImg.src !== image) mainImg.src = image;
    if (sheen) sheen.hidden = !(rInfo.tone === 'holo');

    priceEl.textContent = formatMoney(variant.price);
    const avail = !!variant.buyable;
    const q = variant.count || 0;
    let stockText;
    if (!avail) stockText = 'Esaurito';
    else if (variant.inventory_management && q > 0 && q <= 3) stockText = 'Ultimi ' + q + ' pz';
    else if (variant.inventory_management && q > 0) stockText = 'Disponibile · ' + q + ' pz';
    else stockText = 'Disponibile';
    stockEl.textContent = stockText;
    stockEl.dataset.in = avail;
    stockEl.dataset.low = (avail && variant.inventory_management && q > 0 && q <= 3) ? 'true' : 'false';

    variantIdEl.value = String(variant.id);
    syncQtyInput(variant);
    addBtn.disabled = !avail;
    addLabel.textContent = avail ? 'Aggiungi al carrello' : 'Esaurito';
    if (buyNow) buyNow.disabled = !avail;

    root.querySelectorAll('[data-tcg-options]').forEach(group => {
      const which = group.dataset.tcgOptions;
      group.querySelectorAll('.tcg__pill').forEach(pill => {
        const val = pill.dataset.value;
        pill.setAttribute('aria-pressed', sel[which] === val ? 'true' : 'false');
        let ok;
        if (which === 'option1') ok = isAvail({ ...sel, option1: val });
        else if (which === 'option2') ok = variants.some(v => v.option2 === val && v.buyable);
        else ok = true;
        pill.toggleAttribute('disabled', !ok);
      });
    });

    rarityWrap.querySelectorAll('.tcg__rc').forEach(c => {
      const key = c.dataset.rarity;
      c.setAttribute('aria-pressed', key === sel.option3 ? 'true' : 'false');

      const langPool = variants.filter(v => v.option3 === key && v.option2 === sel.option2);
      const langBuyable = langPool.filter(v => v.buyable);
      const langQty = langBuyable.reduce((s, v) => s + v.count, 0);
      // Esaurita nella lingua corrente ma acquistabile in un'altra: la card resta cliccabile
      // (selectRarity passa da sola alla lingua disponibile) invece di sembrare esaurita.
      const otherBuyable = langBuyable.length === 0
        ? variants.filter(v => v.option3 === key && v.buyable)
        : [];
      let cardStatus;
      if (langBuyable.length === 0) cardStatus = otherBuyable.length > 0 ? 'other' : 'out';
      else if (langQty > 0 && langQty <= 3) cardStatus = 'low';
      else cardStatus = 'in';

      const statEl = c.querySelector('.tcg__rc-stat');
      if (statEl) {
        statEl.textContent = { in: 'Disponibile', low: 'Pochi pezzi', out: 'Esaurito', other: 'Altra lingua' }[cardStatus];
        statEl.className = `tcg__rc-stat ${cardStatus === 'other' ? 'low' : cardStatus}`;
      }
      const pool = langPool.length > 0 ? langPool : variants.filter(v => v.option3 === key);
      const priceSource = langBuyable.length > 0 ? langBuyable : otherBuyable.length > 0 ? otherBuyable : pool;
      const rcPriceEl = c.querySelector('.tcg__rc-price');
      if (rcPriceEl) rcPriceEl.textContent = formatMoney(Math.min(...priceSource.map(v => v.price)));

      c.classList.toggle('is-out', cardStatus === 'out');
      c.disabled = cardStatus === 'out';
    });

    const selImgId = (variant && variant.featured_image && variant.featured_image.id != null)
      ? String(variant.featured_image.id)
      : null;
    root.querySelectorAll('[data-tcg-variant-thumb]').forEach(t =>
      t.setAttribute('aria-pressed', (selImgId && t.dataset.tcgImgId === selImgId) ? 'true' : 'false'));

    setText('[data-tcg-d-rarity]', rInfo.name || rInfo.badge);
    setText('[data-tcg-d-lang]', sel.option2);
    setText('[data-tcg-d-cond]', sel.option1);
    setText('[data-tcg-d-sku]', variant.sku || '-');

    const stickyMeta = [rInfo.name || rInfo.badge, sel.option1, sel.option2].filter(Boolean).join(' · ');
    setText('[data-tcg-sticky-price]', formatMoney(variant.price));
    setText('[data-tcg-sticky-meta]', stickyMeta);
    const sAdd = $('[data-tcg-sticky-add]');
    if (sAdd) {
      sAdd.disabled = !avail;
      sAdd.textContent = avail ? 'Aggiungi' : 'Esaurito';
    }
  }
  function setText(q, t) {
    const el = $(q);
    if (el) el.textContent = t;
  }

  /* ---------- buy now / sticky add submit the same form ---------- */
  const form = root.querySelector('form');
  function activeVariant() {
    return findVariant(sel) || variants.filter(v => v.option3 === sel.option3).find(v => v.buyable) || variants.filter(v => v.option3 === sel.option3)[0] || null;
  }
  async function submitCart(goToCheckout) {
    const active = activeVariant();
    if (!active) return;
    variantIdEl.value = String(active.id);
    syncQtyInput(active);
    const limit = quantityLimitFor(active);
    let qty = Math.max(1, parseInt((qtyInput && qtyInput.value) || '1', 10) || 1);
    if (limit != null) qty = Math.min(qty, limit);
    if (qtyInput) qtyInput.value = String(qty);
    const payload = new URLSearchParams();
    payload.set('id', String(active.id));
    payload.set('quantity', String(qty));
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: payload.toString()
    });
    const json = await res.json().catch(() => null);
    if (!res.ok) {
      window.alert((json && (json.description || json.message)) || 'Errore aggiunta al carrello');
      return;
    }
    await refreshCartBadge();
    if (goToCheckout) {
      window.location.href = '/checkout';
      return;
    }
    addLabel.textContent = 'Aggiunto al carrello';
    window.setTimeout(() => {
      const activeNow = activeVariant();
      const availNow = !!(activeNow && activeNow.buyable);
      addLabel.textContent = availNow ? 'Aggiungi al carrello' : 'Esaurito';
    }, 1600);
  }
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      submitCart(false);
    });
  }
  if (qtyInput) {
    // Solo aggiornamento bottoni +/- durante la digitazione — niente clamp qui (vedi commento
    // su syncQtyButtons): altrimenti scrivere un numero di due cifre con scorta a una cifra
    // faceva saltare il campo al massimo a metà digitazione.
    qtyInput.addEventListener('input', () => {
      syncQtyButtons(activeVariant());
    });
    // Clamp definitivo solo a digitazione conclusa (tab via / click altrove).
    qtyInput.addEventListener('blur', () => {
      setQty(currentQty(), activeVariant());
    });
  }
  if (qtyMinus) {
    qtyMinus.addEventListener('click', () => setQty(currentQty() - 1, activeVariant()));
  }
  if (qtyPlus) {
    qtyPlus.addEventListener('click', () => setQty(currentQty() + 1, activeVariant()));
  }
  if (buyNow) buyNow.addEventListener('click', () => {
    if (!buyNow.disabled) submitCart(true);
  });
  const sAdd = $('[data-tcg-sticky-add]');
  if (sAdd) sAdd.addEventListener('click', () => {
    if (!sAdd.disabled) submitCart(false);
  });

  refreshCartBadge().catch(() => {});
  render();
})();
